import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-51">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-52">
          {/* Text Content */}
          <div className="lg:col-span-7 text-center lg:text-left mb-12 lg:mb-0" data-id="element-53">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-light text-brand-teal font-semibold text-sm mb-6 border border-brand-teal/20" data-id="element-54">
              <Star className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-55" />
              <span data-id="element-56">Más de 2,000 familias transformadas</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-teal leading-tight mb-6" data-id="element-57">
              Tu hijo no tiene un problema de conducta.{' '}
              <br className="hidden lg:block" data-id="element-58" />
              <span className="text-brand-gold relative" data-id="element-59">
                Tiene un cuerpo intoxicado
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-brand-gold/30" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-60">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-61" />
                </svg>
              </span>{' '}
              esperando ser liberado.
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto lg:mx-0" data-id="element-62">
              El protocolo biológico de 90 días para sanar el intestino, barrer
              los metales pesados y recuperar la mirada de tu hijo{' '}
              <strong className="text-brand-teal" data-id="element-63">
                sin laboratorios caros ni suplementos inaccesibles.
              </strong>
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-64">
              <Button href="https://www.elplacerquenutre.com/cart/45339963195494:1" className="w-full sm:w-auto text-sm sm:text-base" data-id="element-65">
                SÍ, QUIERO RECUPERAR LA CONEXIÓN CON MI HIJO
              </Button>
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-sm text-gray-500" data-id="element-66">
              <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-67" />
              <span data-id="element-68">Garantía de 7 días. Pago 100% seguro.</span>
            </div>
          </div>

          {/* Product Mockup Image + Emotional Photos */}
          <div className="lg:col-span-5 relative" data-id="element-69">
            <div className="relative mx-auto w-full max-w-lg" data-id="element-70">
              {/* Decorative background blobs */}
              <div className="absolute top-0 -left-4 w-72 h-72 bg-brand-gold rounded-full mix-blend-multiply filter blur-2xl opacity-20" data-id="element-71"></div>
              <div className="absolute top-0 -right-4 w-72 h-72 bg-brand-teal rounded-full mix-blend-multiply filter blur-2xl opacity-15" data-id="element-72"></div>
              <div className="absolute -bottom-8 left-20 w-72 h-72 bg-brand-light rounded-full mix-blend-multiply filter blur-2xl opacity-40" data-id="element-73"></div>

              {/* Emotional Photos - Side by Side Cards */}
              <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 relative z-10" data-id="element-74">
                <div className="rounded-2xl overflow-hidden shadow-lg border-2 border-white/80" data-id="element-75">
                  <img src="https://cdn.magicpatterns.com/uploads/5tvDNhwNGJR7j3BQwQyA6L/Mirada.png" alt="Madre buscando la mirada de su hijo" className="w-full aspect-[3/4] object-cover" data-id="element-76" />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg border-2 border-white/80" data-id="element-77">
                  <img src="https://cdn.magicpatterns.com/uploads/1Dy12mGD2ubaLLZAkNP452/Abrazo.png" alt="Madre abrazando a su hijo con conexión" className="w-full aspect-[3/4] object-cover" data-id="element-78" />
                </div>
              </div>

              {/* Actual Product Mockup */}
              <div className="relative" data-id="element-79">
                <img src="https://cdn.magicpatterns.com/uploads/p1YfsYEoTumYpqvMUFjHLB/mockup_completo.png" alt="Protocolo Intestino Limpio, Mente Sana - Pack completo con ebook, guías, recetario y diario de evolución" className="w-full h-auto rounded-xl drop-shadow-2xl relative z-10" data-id="element-80" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}